
import {
  defineComponent,
  onBeforeUpdate,
  PropType,
  reactive,
  ref,
  toRefs,
  watch
} from 'vue'
import LabelBox from '@/pages/Products/components/LabelBox.vue'
import { CtProp, CtStockItem } from '@/models/interfaces/content-type'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import DButton from '@/components/base/DButton.vue'
import TickIcon from '@/components/Icons/TickIcon.vue'
import CloseIcon from '@/components/Icons/CloseIcon.vue'
import AddIcon from '@/components/Icons/AddIcon.vue'
import { generateUUID } from '@Protium/vue-ozone-utils'
import PropertyInfoItem from '@/pages/Products/ProductDetail/components/PropertyInfoItem.vue'
import { debounce, isEqual } from 'lodash'

export default defineComponent({
  name: 'PropertyInformation',
  components: { PropertyInfoItem, AddIcon, CloseIcon, TickIcon, DButton, EditableBlockInput, LabelBox },
  props: {
    props: {
      type: Object as PropType<CtStockItem['props']>,
      default: () => ({}),
    },
    allProps: {
      type: Array as PropType<CtProp[]>,
      default: () => []
    },
    newProps: {
      type: Object as PropType<{ [key: string]: CtProp }>,
      default: () => ({})
    },
    editing: {
      type: Boolean,
      default: false,
    },
    propValues: {
      type: Object as PropType<{ [key: string]: Array<string> }>,
      default: () => ({})
    }
  },
  emits: ['update:props', 'update:new-props'],
  setup (props, { emit }) {

    const updatePropId = (oldPropId, newPropId) => {
      emit('update:props', Object.fromEntries(
        Object.entries(props.props ?? {})
          .map(([id, val]) => id === oldPropId ? [newPropId, val] : [id, val])
      ))
    }

    const updatePropValue = (propId, newValue) => {
      emit('update:props', { ...(props.props ?? {}), [propId]: newValue })
    }

    onBeforeUpdate(() => newNewProps.value = {})

    const newNewProps = ref<{[key: string]: CtProp}>({})

    watch(() => isEqual(newNewProps.value, props.newProps),
      debounce((equal) => !equal ? emit('update:new-props', newNewProps.value) : undefined, 500)
    )

    const addProperty = () => {
      emit('update:props', {
        ...(props.props ?? {}),
        [generateUUID()]: ''
      })
    }

    const removeProp = (propId) => {
      const { [propId]: _, ...newProps } = props.props ?? {}
      emit('update:props', newProps)
    }

    const state = reactive({
      newPropName: {
        value: generateUUID(),
        label: ''
      },
    })

    return {
      newNewProps,
      updatePropId,
      updatePropValue,
      ...toRefs(state),
      addProperty,
      removeProp,
    }
  }
})
